import useAxios from "./use-axios";

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const useCreateProject = () => {
  return useAxios(
    {
      url: "/project",
      method: "POST",
    },
    { manual: true }
  );
};

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const useProjects = (limit, offset, searchTerm) => {
  return useAxios({
    url: "/project",
    params: { limit, offset, searchTerm },
  });
};

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const useProject = (id, isPublic) => {
  return useAxios({
    url: `/project/${id}`,
    params: { isPublic },
  });
};

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const usePatchProject = (userId) =>
  useAxios(
    {
      url: `/project/${userId}`,
      method: "PATCH",
    },
    { manual: true }
  );

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const useDeleteProject = (id) => {
  return useAxios(
    {
      url: `/project/${id}`,
      method: "DELETE",
    },
    { manual: true }
  );
};

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const useStartProcessingProject = (id) => {
  return useAxios(
    {
      url: `/project/${id}/start-processing`,
      method: "POST",
    },
    { manual: true }
  );
};

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const useStopProcessingProject = (id) => {
  return useAxios(
    {
      url: `/project/${id}/stop-processing`,
      method: "POST",
    },
    { manual: true }
  );
};

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const useProjectProgress = (id) => {
  return useAxios(
    {
      url: `/project/${id}/progress`
    }
  );
};
